/*
 *
 * File JS per la Homepage
 *
 */

import "./general.scss";

// IMPORT COMPONENTI
//--------------------------------------------------------------------//
import initHeader from "components/header/header";
import animateIn from "animations/animate-in/animate-in";
import breadcrumbs from "components/breadcrumbs/breadcrumbs";
import button from "components/buttons/buttons";
import cmsContent from "components/cms-content/cms-content";
import heroText from "components/hero-text/hero-text";
import footer from "components/footer/footer";
import contactForm from "components/contact-form/contact-form";
import accordion from "imComponents/accordion/accordion";
import titleBox from "components/title-box/title-box";
import customAccordion from "components/custom-accordion/custom-accordion";
import boxImage from "components/box-image/box-image";
import boxVideo from "components/box-video/box-video";
import boxText from "components/box-text/box-text";
import sliderTextImg from "components/slider-text-img/slider-text-img";
import cardTextImg from "components/cards/card-text-img";
import customQuote from "components/custom-quote/custom-quote";
import boxCardsTextImg from "components/box-cards-text-img/box-cards-text-img";
import colTitleText from "components/col-title-text/col-title-text";
import modal from "imComponents/modal/modal";
import blockMasonry from "components/block-masonry/block-masonry";
import gallery from "components/gallery/gallery";

//
//
//
//--------------------------------------------------------------------//
//--------------------------------------------------------------------//
// INIT COMPONENTI
//--------------------------------------------------------------------//
function initAllComponents() {
    if (!document.querySelector("body.wp-admin")) {
        initHeader();
    }
    animateIn();
    accordion();
    sliderTextImg();
    modal();
    blockMasonry();
    gallery();
}
if (document.querySelector("body.wp-admin")) {
    (function ($) {
        var initBlock = function ($block) {
            initAllComponents();
        };
        if (window.acf) {
            window.acf.addAction("render_block_preview", initBlock);
        }
    })(jQuery);
}
initAllComponents();
//--------------------------------------------------------------------//
//
//
